import { SxProps, Theme } from "@mui/material";
import Image from "next/image";
import affirmLogoLong from "@/public/assets/images/affirm-logo-long.svg";
import affirmLogo from "@/public/assets/images/affirm-logo.svg";
import InlineLogo from "./inlineLogo";

export const AffirmInlineLogo = (props: {
  size?: number;
  withName?: boolean;
  sx?: SxProps<Theme>;
}) => {
  return <InlineLogo name="Affirm" logoSrc={affirmLogo} {...props} />;
};

export const AffirmLogo = () => (
  <Image width={90} height={28} alt="Affirm full logo" src={affirmLogoLong} />
);
